// extracted by mini-css-extract-plugin
export default {"buttan":"Top_buttan__kH44D","animShadow":"Top_animShadow__NqjdD","ani":"Top_ani__xmC21"};